export default "__VITE_ASSET__D2uWY1aR__"